// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".auth-login[data-v-71e66d12] {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.auth-login .el-form[data-v-71e66d12] {\n    width: 100%;\n    max-width: 500px;\n}\n", ""]);
// Exports
module.exports = exports;
